import { CreateUpdateScopeComponent } from '../create-update-scope/create-update-scope.component';
import { handleApiErrors } from '../../../../../core/data-access/http-client/interceptors/error.interceptor';
import { SharedTableComponent } from '../../../../../../trash/shared/components/shared-table/shared-table.component';
import { ErrorOrError } from '../../../../../core/results/error-or/models/error-or-error.model';
import { ScopeItem, ScopesListApiResponse } from '../../dtos/responses/scopes-list-response';
import { ToastService } from '../../../../../../trash/shared/components/toasters/Toast.service';
import { BaseComponent } from '../../../../../../trash/shared/components/base/base.component';
import { SahredConstants } from '../../../../../../trash/shared/constants/Values';
import { ScopesService } from '../../services/accounts.service';
import { Subscription, tap, catchError, finalize } from 'rxjs';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { SkeletonModule } from 'primeng/skeleton';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { RevokePermissionsComponent } from '../../../../../../views/pages/user-management/account/roles/revoke-permissions/revoke-permissions.component';
import { Logger } from '../../../../../core/utilities/logging/logger';
import { UserManagementPermissions } from '../../../../common/permissions/user-management.permissions';
import { UserContextService } from '../../../../auth-management/authentication/services/user-context.service';
import { AssignRevokePermissionsComponent } from '../../../../permission-management/permission-groups/conmponents/assign-permissions/assign-revoke-permissions.component';
import { UserManagementCollections } from '../../../../common/collections/user-management.collections';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IMenuItemAction } from '../../../../../core';

@Component({
  selector: 'app-scopes-list',
  standalone: true,
  imports: [SkeletonModule, CommonModule, RouterModule, ButtonModule, MenuModule, SharedTableComponent, TranslateModule],
  templateUrl: './scopes-list.component.html',
  styleUrl: './scopes-list.component.scss',
  providers: [DialogService]
})
export class ScopesListComponent extends BaseComponent<any> {
  private subscriptions: Subscription[] = [];
  ScopesRes: ScopesListApiResponse | null = null;
  totalItemCount: number = 0;
  isLoadingItems: boolean = false;
  isLoadingFilter: boolean = false;
  searchTerm: string | null = null;

  items = {
    headers: ['GENERAL.NAME', 'GENERAL.ACTIONS'],
    data: [] as ScopeItem[],
    dataKeys: ['englishName', 'action']
  };

  viewItem: boolean = UserContextService.hasPermission(UserManagementPermissions.Scopes.Read);
  addItem: boolean = UserContextService.hasPermission(UserManagementPermissions.Scopes.Create);
  editItem: boolean = UserContextService.hasPermission(UserManagementPermissions.Scopes.Update);
  assignRevokePermissions: boolean = true;

  actionsList: IMenuItemAction[] = [];

  constructor(
    private _ScopesService: ScopesService,
    private toastService: ToastService,
    private dialog: DialogService,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    super();
  }

  override ngOnInit(): void {
    this.actionsList = [
      ...(this.editItem
        ? [
          {
            label: this.translate.instant('ACTIONS.EDIT'),
            icon: 'pi pi-pen-to-square',
            command: (event: any) => {
              this.openScopeDialog(event, true);
            },
            isView: this.editItem
          }
        ]
        : []),
      ...(this.viewItem
        ? [
          {
            label: this.translate.instant('ACTIONS.VIEW'),
            icon: 'pi pi-eye',
            command: (event: any) => {
              this.openScopeDialog(event, false);
            },
            isView: this.viewItem
          }
        ]
        : []),
      ...(this.assignRevokePermissions
        ? [
          {
            label: `${this.translate.instant('GENERAL.ASSIGN')}/${this.translate.instant('GENERAL.REVOKE')} ${this.translate.instant('GENERAL.PERMISSIONS')}`,
            icon: 'pi pi-plus',
            command: (event: any) => {
              Logger.debug('event', event);
              this.assignPermissions(event);
            },
            isView: this.assignRevokePermissions
          }
        ]
        : [])
    ];
    this.list(true);
  }

  // Start Get Listing Functions
  async list(filter?: boolean) {
    if (this.HandelRenderingDataMessage) {
      this.HandelRenderingDataMessage = 'GENERAL.LOADING';
    }

    filter ? (this.isLoadingFilter = true) : (this.isLoadingItems = true);
    let RolesSubscription: Subscription = this._ScopesService
      .getAll(this.request)
      .pipe(
        tap((res: ScopesListApiResponse) => this.processListResponse(res)),
        catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
        finalize(() => this.finalizeListRequest())
      )
      .subscribe();

    this.subscriptions.push(RolesSubscription);
  }
  private processListResponse(response: ScopesListApiResponse): void {
    if (response) {
      this.ScopesRes = response;
      this.totalItemCount = response.paginationMetadata.totalItemCount ?? 0;
      this.items.data = this.ScopesRes.items;
      if (this.ScopesRes.items.length == 0) {
        this.HandelRenderingDataMessage = 'GENERAL.NO_DATA_FOUND';
      }
      this.cdr.markForCheck();
    } else {
      this.HandelRenderingDataMessage = 'GENERAL.NO_DATA_FOUND';
    }
  }
  private finalizeListRequest(): void {
    this.isLoadingItems = false;
    this.isLoadingFilter = false;
  }
  //  End Get Listing Functions

  openScopeDialog(item?: ScopeItem | null, visible?: boolean) {
    let headerTitle: string;
    if (visible == false) {
      headerTitle = this.translate.instant('USER_MANAGEMENT.SCOPE_DETAILS');
    } else {
      headerTitle = `${item ? this.translate.instant('ACTIONS.EDIT') : this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('USER_MANAGEMENT.SCOPE')}`;
    }
    const ref: any = this.dialog.open(CreateUpdateScopeComponent, {
      data: {
        item: item,
        visible: visible
      },
      header: headerTitle,
      styleClass: 'responsive-dialog-width'
    });
    ref?.onClose.subscribe((isSuccess: boolean) => {
      if (isSuccess) {
        setTimeout(async () => {
          await this.list();
        }, 1000);
      }
    });
  }
  private assignPermissions(item: ScopeItem): void {
    let scopeId = item.id;
    const endPoint = UserManagementCollections.ScopePermissions(scopeId);

    const ref = this.dialog.open(AssignRevokePermissionsComponent, {
      data: {
        item: item,
        type: 'assign',
        visible: true,
        endPoint: endPoint
      },
      header: `${this.translate.instant('GENERAL.ASSIGN')}/${this.translate.instant('GENERAL.REVOKE')} ${this.translate.instant('GENERAL.PERMISSIONS')}`,
      styleClass: 'responsive-dialog-width'
    });
    ref?.onClose?.subscribe((item?: any) => {
      if (item) {
        this.resetParams();
        this.list();
      }
    });
  }

  resetParams(): void {
    this.page = 1;
    this.request.page = SahredConstants.INITIAL_PAGE_INDEX;
    this.request.pageSize = SahredConstants.INITIAL_PAGE_SIZE;
    this.searchTerm = null;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      if (subscription && !subscription.closed) {
        subscription.unsubscribe();
      }
    });
  }
}
